import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export default function PageTransition({ children }) {
  const location = useLocation();
  const first = useRef(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 550);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <>
      {loading && (
        <div className="route-loader">
          <div className="route-loader-spinner" />
        </div>
      )}
      {children}
    </>
  );
}